import * as constants from 'common/constants';

export const updateLocation = payload => ({
  type: constants.UPDATE_LOCATION,
  payload,
});

export const updateZoom = payload => ({
  type: constants.UPDATE_ZOOM,
  payload,
});

export const updateBounds = payload => ({
  type: constants.UPDATE_BOUNDS,
  payload,
});

export const updateFormName = payload => ({
  type: constants.UPDATE_FORM_NAME,
  payload,
});

export const updateMapFields = payload => ({
  type: constants.UPDATE_MAP_FIELDS,
  payload,
});

export const updateMapStorages = payload => ({
  type: constants.UPDATE_MAP_STORAGES,
  payload,
});



// WEBPACK FOOTER //
// ./src/actions/map.js